import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ContactPanel } from '../components/ContactPanel';
import { CheckCircle, Star, Users, Heart, Award, Shield } from 'lucide-react';
export const About = () => {
  const values = [{
    icon: CheckCircle,
    title: 'Reliable',
    description: 'We arrive on time and complete repairs to the highest standards'
  }, {
    icon: Shield,
    title: 'Transparent',
    description: "Clear pricing with no hidden fees—you know exactly what you're paying for"
  }, {
    icon: Heart,
    title: 'Polite',
    description: 'Friendly, respectful service that treats your home with care'
  }, {
    icon: Award,
    title: 'Professional',
    description: 'Qualified engineers working safely to manufacturer standards'
  }];
  const reviews = [{
    text: 'Brilliant same-day response. Engineer was polite and fixed our washer in one visit.',
    author: 'J. Turner, Manchester'
  }, {
    text: 'Clear pricing and tidy work. No mess left behind. Would definitely use again.',
    author: 'A. Patel, Birmingham'
  }, {
    text: 'Fixed our washer first visit. Very professional and explained everything clearly.',
    author: 'S. Bennett, Leeds'
  }];
  return <div className="min-h-screen bg-slate-50" style={{
    width: '100%'
  }} data-id="element-209">
      <Header data-id="element-210" />
      <section className="py-20 bg-gradient-to-br from-blue-700 to-blue-900 text-white" data-id="element-211">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
          <h1 className="text-5xl font-bold mb-6" data-id="element-213">About Us</h1>
          <p className="text-xl text-blue-50 max-w-3xl" data-id="element-214">
            Your trusted partner for professional appliance repairs across the
            UK
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-215">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-12" data-id="element-217">
            <div className="flex items-center space-x-3 mb-6" data-id="element-218">
              <Users className="w-8 h-8 text-blue-700" data-id="element-219" />
              <h2 className="text-3xl font-bold text-slate-800" data-id="element-220">Who We Are</h2>
            </div>
            <p className="text-lg text-slate-600 leading-relaxed mb-6" data-id="element-221">
              We're a UK team specialising in domestic appliance repairs—washing
              machines, dishwashers, tumble dryers, cookers, fridges and TVs. We
              listen carefully, arrive on time and carry out work safely to
              manufacturer standards.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed mb-8" data-id="element-222">
              Our goal is simple: reliable repairs, delivered professionally.
              Every engineer in our network is fully vetted and trained to
              diagnose and fix appliance faults quickly and efficiently.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-223">
              Whether it's an emergency repair or scheduled maintenance, we're
              here to help keep your home running smoothly with honest advice
              and quality workmanship.
            </p>
          </div>
          <div className="mb-12" data-id="element-224">
            <h2 className="text-3xl font-bold text-slate-800 text-center mb-8" data-id="element-225">
              Our Values
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-226">
              {values.map((value, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-227">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4" data-id="element-228">
                    <value.icon className="w-6 h-6 text-blue-700" data-id="element-229" />
                  </div>
                  <h3 className="text-xl font-semibold text-slate-800 mb-2" data-id="element-230">
                    {value.title}
                  </h3>
                  <p className="text-slate-600" data-id="element-231">{value.description}</p>
                </div>)}
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-12" data-id="element-232">
            <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-233">
              What Our Customers Say
            </h2>
            <div className="space-y-6" data-id="element-234">
              {reviews.map((review, index) => <div key={index} className="bg-slate-50 p-6 rounded-lg border-l-4 border-blue-700" data-id="element-235">
                  <div className="flex items-center mb-3" data-id="element-236">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-237" />)}
                  </div>
                  <p className="text-slate-700 text-lg mb-2" data-id="element-238">"{review.text}"</p>
                  <p className="text-slate-500 font-medium" data-id="element-239">
                    — {review.author}
                  </p>
                </div>)}
            </div>
          </div>
          <ContactPanel data-id="element-240" />
        </div>
      </section>
      <Footer data-id="element-241" />
    </div>;
};